import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25a5f2a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "player-container" }
const _hoisted_2 = { class: "player" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "no-image"
}

import {PropType, Ref, ref, useSlots, watch} from "vue";
import OverlayableImage from "@/lib/components/frame/image/OverlayableImage.vue";
import CarouselControlsBar from "@/lib/components/frame/carousel/CarouselControlsBar.vue";
import _ from "lodash";
import {CarouselShortcut} from "@/lib/components/frame/carousel/type/CarouselShortcut";
import {SImageData} from "@/lib/store/model/media/SImageData";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'OverlayableImagesCarousel',
  props: {
  images: Array as PropType<SImageData[]>,
  shortcuts: Array as PropType<CarouselShortcut[]>
},
  emits: [
  "onImageSelectedBefore",
  "onImageSelectedAfter",
],
  setup(__props, { expose, emit: emits }) {

const props = __props






const slots = useSlots();

const hasSlot = (name: string) => !!slots[name];

// ------------------------------
//  Image selection handling
// ------------------------------

const selectedImage: Ref<SImageData|undefined> = ref();

const onImageSelected = (image: SImageData) =>
{
  emits("onImageSelectedBefore", {
    image: image,
    selectedImage: selectedImage.value
  });

  selectedImage.value = image;

  emits("onImageSelectedAfter", selectedImage.value);
}

// ------------------------------
//  Images providing listener
// ------------------------------

watch(() => props.images, () =>
{
  if (props.images)
  {
    const firstImage = _.first(props.images);

    if (firstImage)
      onImageSelected(firstImage);
  }
})

// ------------------------------
//  Ref exposition
// ------------------------------

const carouselImages = ref([])

expose({
  carouselImages
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: image.instanceId,
          class: "overlayable-image-container",
          id: 'overlayable-image-container-'+ image.instanceId
        }, [
          _createVNode(OverlayableImage, {
            image: image,
            ref_for: true,
            ref_key: "carouselImages",
            ref: carouselImages
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, 'overlay ' + image.instanceId)
            ]),
            _: 2
          }, 1032, ["image"])
        ], 8, _hoisted_3)), [
          [_vShow, selectedImage.value && image.instanceId === selectedImage.value.instanceId]
        ])
      }), 128)),
      (typeof __props.images === 'undefined' || !__props.images.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!hasSlot('no-image-loaded-message'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No image loaded"))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "no-image-loaded-message")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CarouselControlsBar, {
      images: __props.images,
      "selected-image": selectedImage.value,
      shortcuts: __props.shortcuts,
      onOnImageSelected: onImageSelected
    }, null, 8, ["images", "selected-image", "shortcuts"])
  ]))
}
}

})